const development = {
  apiUrl: "https://localhost:7129/api",
  tokenPrefix: "lottery_dev_",
};
const production = {
  apiUrl: "https://lottomania.gr/api",
  tokenPrefix: "lottery_production_",
};

interface IUseConfig {
  config: any;
  isDevelopment: boolean;
}

export function useConfig(): IUseConfig {
  let config;
  if (process.env.NODE_ENV === "production") {
    config = production;
  } else {
    config = development;
  }

  return {
    isDevelopment: process.env.NODE_ENV === "development",
    config,
  };
}
